import styled from 'styled-components'

export const BackGround = styled.div`
    width: 100vw;
    overflow: auto;
    background: rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 0;
    right: 0;
    z-index: 8;
    height: 100%;
`
